//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'HelloWorld',
  data () {
    return {
     cur:0
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/HelloWorld.vue